import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UTC_TIMES } from 'data/utc-times';
import moment from 'moment';
import { AddUTCToTimePipe } from 'pipes/add-utc-to-time.pipe';
import { SuppressErrorMatcher } from 'utils/error-matchers/suppress.error-matcher';

@Component({
  selector: 'app-alert-condition',
  standalone: false,
  templateUrl: './alert-condition.component.html',
  styleUrl: './alert-condition.component.scss'
})
export class AlertConditionComponent implements OnInit {
addPoolConsumptionSearch!:FormGroup;
  public suppressErrorState = new SuppressErrorMatcher();
  public utcStartTimes = [...UTC_TIMES];
    public utcEndTimes = [...UTC_TIMES];
    public currentdate:any
    public futuredate:any
  constructor(public fb:FormBuilder, private addUTCToTimePipe: AddUTCToTimePipe){}
  

  ngOnInit(): void {

    
     this.addPoolConsumptionSearch = this.fb.group({
      startTime: this.fb.array([this.getTimeData()]),
      allday:[false],
      percentage:[''],
      next:[''],
      day:[''],
      optionControl:[''],
      Consecutive:['']
    });
        this.addPoolConsumptionSearch.get('day')?.valueChanges.subscribe((ele:any)=>{
       this.momentdate(ele)
    })
  }



  getTimeData() {
    return this.fb.group({
      startTime: ['', [Validators.required,]],
      endTime: ['', [Validators.required,]],
    })
  }

  get FormDatasearchData() {
    return this.addPoolConsumptionSearch.get('startTime') as FormArray;
  }

  Duplicatethedata() {
    return this.FormDatasearchData.push(this.getTimeData());
  }

  removedatafromSearchPool(i: number) {
    if (this.FormDatasearchData.length > 1) {
      this.FormDatasearchData.removeAt(i);
    }
    else {
      const getThresholditemslist = this.FormDatasearchData.at(0);
      getThresholditemslist?.reset();
    }
  }

  get registerFormControl() {
    return this.addPoolConsumptionSearch.controls;
  }

   getValidationcontrols(index: any) {
    let getFormArray = this.addPoolConsumptionSearch.get('startTime') as FormArray;
    const updateformGroup = getFormArray.controls[index] as FormGroup;
    return updateformGroup;
  }
   public addUTCToTime(time: string): string {
    return this.addUTCToTimePipe.transform(time);
  }

  selecteddata(event:any){
    
    if(event.value == 1){
            this.addPoolConsumptionSearch.get('Consecutive')?.enable()
      this.addPoolConsumptionSearch.get('startTime')?.disable()
      this.addPoolConsumptionSearch.get('allday')?.disable()
      this.addPoolConsumptionSearch.get('allday')?.setValue(false)
      this.FormDatasearchData.at(0).reset()
    

    }
    else{
      this.addPoolConsumptionSearch.get('Consecutive')?.disable()
            this.addPoolConsumptionSearch.get('startTime')?.enable()
      this.addPoolConsumptionSearch.get('allday')?.enable()
       this.addPoolConsumptionSearch.get('allday')?.setValue(false)
        this.FormDatasearchData.at(0).reset()
    }
    
  }

  checkstatusallday(event:any){
   
   if(event.checked){
     this.FormDatasearchData.at(0).reset()
    let setstartvalue=this.FormDatasearchData.at(0)
    setstartvalue.patchValue({
       startTime:"00:00" ,
      endTime:"23:45" ,
    })
    setstartvalue.disable()
    
   }else{
     this.FormDatasearchData.at(0).reset()
       this.addPoolConsumptionSearch.get('startTime')?.enable()
   }
   
  }

momentdate(ele:any){
const futureDate = moment().add(ele, 'days');
const todaydate=moment()
this.currentdate=futureDate.format('YYYY-MM-DD');
this.futuredate=todaydate.format('YYYY-MM-DD');

  }
}
